import React, { useContext } from "react";
import Modal from "../UI/Modal";
import Button from "../UI/Button";
import Input from "../UI/Input";
import styles from "./ShipToAccounts.module.css";
import { Search } from "react-feather";
import AppContext from "../../store/app-context";
import { Table,
    Header,
    HeaderRow,
    Body,
    Row,
    HeaderCell,
    Cell } from "@table-library/react-table-library";
import { useTheme } from '@table-library/react-table-library/theme';
import { getTheme } from '@table-library/react-table-library/baseline';

const ShipToAccounts = (props) => {
  const appCtx = useContext(AppContext);

  let label_multi_addr = 'Multiple Addresses Available';
  let label_multi_ship_select = 'This account is associated with multiple delivery addresses. Please select the address you want to use for this order.';
  let label_institution = 'Institution';
  let label_cityTown = 'City/Town';
  let label_state = 'State/Province';
  let label_zip = 'Zip Code';
  let label_use_this_addr = 'Use this address';
  let label_close = 'Close';
  let label_current_selection = 'Current Selection';

  if(appCtx && appCtx.bioradResources){
    label_multi_addr = appCtx.bioradResources.Multi_Addr ? appCtx.bioradResources.Multi_Addr : 'Multiple Addresses Available';
    label_multi_ship_select = appCtx.bioradResources.Multi_Ship_Select ? appCtx.bioradResources.Multi_Ship_Select : 'This account is associated with multiple delivery addresses. Please select the address you want to use for this order.';
    label_institution = appCtx.bioradResources.Institution ? appCtx.bioradResources.Institution : 'Institution';
    label_cityTown = appCtx.bioradResources.City_Town ? appCtx.bioradResources.City_Town : 'City/Town';
    label_state = appCtx.bioradResources.State ? appCtx.bioradResources.State : 'State/Province';
    label_zip = appCtx.bioradResources.Postal_Code ? appCtx.bioradResources.Postal_Code : 'Zip Code';
    label_use_this_addr = appCtx.bioradResources.Use_This_Addr ? appCtx.bioradResources.Use_This_Addr : 'Use this address';
    label_close = appCtx.bioradResources.Link_Close ? appCtx.bioradResources.Link_Close : 'Close';
    label_current_selection = appCtx.bioradResources.Current_Selection ? appCtx.bioradResources.Current_Selection : 'Current Selection';
  }

  let data = {nodes: props.shipAddresses};
  const theme = useTheme(getTheme());

  const [search, setSearch] = React.useState("");

  const handleSearch = (event) => {
    setSearch(event.target.value);
  };

  data = {
    nodes: data.nodes.filter((item) =>
      (item.label && item.label.toLowerCase().includes(search.toLowerCase()))
      ||
      (item.firstName && item.firstName.toLowerCase().includes(search.toLowerCase()))
      ||
      (item.addressLine1 && item.addressLine1.toLowerCase().includes(search.toLowerCase()))
      ||
      (item.city && item.city.toLowerCase().includes(search.toLowerCase()))
      ||
      (item.state && item.state.toLowerCase().includes(search.toLowerCase()))
      ||
      (item.zipCode && item.zipCode.toLowerCase().includes(search.toLowerCase()))
    ),
  };

  return (
    <Modal onClose={props.onClose}>
      <div>
        <strong>{label_multi_addr}</strong>
        <p>{label_multi_ship_select}</p>
      </div>
      <div className="section">
        <div className="inputsection">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#01892A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
            <Input
            allowClear
            input={{
                id: "search",
                className: "searchAddresslist",
                type: "text",
                name: "search",
                prefix: <Search color="#01892A" />,
                placeholder: "Search Address List",
                size: "large",
                value: search,
                //onInput: handleSearch
                onChange: handleSearch
            }}
            />
        </div>
      </div>
      <div className={styles.displayAccounts}>
      {props.shipAddresses && (
        <Table data={data} theme={theme}>
            {(tableList) => (
                <>
                    <Header>
                        <HeaderRow>
                            <HeaderCell>{label_institution}</HeaderCell>
                            <HeaderCell>{label_cityTown}</HeaderCell>
                            <HeaderCell>{label_state}</HeaderCell>
                            <HeaderCell>{label_zip}</HeaderCell>
                        </HeaderRow>
                    </Header>
                    <Body>
                        {tableList.map((item) => (
                        <Row key={item.label} item={item}>
                            <Cell>
                                {props.selectedShipToAddress === item.label && (
                                  <span>{label_current_selection}<br /></span>
                                )}
                                {item.firstName && item.firstName.toUpperCase() !== 'NULL' && (item.firstName)}<br />{item.addressLine1 && item.addressLine1.toUpperCase() !== 'NULL' && (item.addressLine1)}<br />
                                {props.selectedShipToAddress !== item.label && (
                                <Button
                                    onClick={() =>
                                    props.accountChangeHandler(
                                        props.acctNumber,
                                        item,
                                        props.companyName,
                                        props.salesOrg,
                                        props.fullSAPAccountNumber
                                    )
                                    }
                                >
                                    {label_use_this_addr}
                                </Button>
                                )}
                            </Cell>
                            <Cell>{item.city && item.city.toUpperCase() !== 'NULL' && (item.city)}</Cell>
                            <Cell>{item.state && item.state.toUpperCase() !== 'NULL' && (item.state)}, {item.countryCode && item.countryCode.toUpperCase() !== 'NULL' && (item.countryCode)}</Cell>
                            <Cell>{item.zipCode && item.zipCode.toString().toUpperCase() !== 'NULL' && (item.zipCode)}</Cell>
                        </Row>
                        ))}
                    </Body>
                </>
            )}
        </Table>
      )}
      </div>
      <div>
        <Button className={styles.closeModal} onClick={props.onClose}>
          {label_close}
        </Button>
      </div>
    </Modal>
  );
};

export default ShipToAccounts;
